import React from 'react';
import { motion } from 'framer-motion';
export function Testimonials() {
  const testimonials = [{
    text: '"Apliqué el guión del Tomo 3 el mismo día que lo leí. El dueño me dijo que era caro y por primera vez en mi carrera respondí sin ponerme a la defensiva. No bajé el precio. El tipo aprobó el presupuesto completo."',
    name: 'Martín G.',
    role: 'Buenos Aires — Veterinario clínico',
    initial: 'M'
  }, {
    text: '"El protocolo para malas noticias me cambió la vida. Antes salía de esas consultas destruida. Ahora tengo un mapa claro y el propietario sale contenido. Llevo 3 semanas aplicándolo."',
    name: 'Sofía R.',
    role: 'Córdoba — Veterinaria de pequeños animales',
    initial: 'S'
  }, {
    text: '"El Tomo 5 sobre el propietario que llega con el diagnóstico de TikTok vale la compra entera. En una semana ya sabía cómo manejar esas consultas sin confrontar y sin perder autoridad clínica."',
    name: 'Luciana P.',
    role: 'Rosario — Veterinaria con consultorio propio',
    initial: 'L'
  }];
  return <section className="bg-white py-10 sm:py-16 px-5" data-id="element-268">
      <div className="max-w-6xl mx-auto" data-id="element-269">
        <div className="text-center text-[10px] sm:text-xs font-semibold tracking-[0.14em] uppercase text-green mb-2 sm:mb-3" data-id="element-270">
          Lo que dicen los veterinarios
        </div>
        <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-bold text-center text-navy mb-8 sm:mb-12 leading-tight" data-id="element-271">
          Resultados reales en el consultorio
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6" data-id="element-272">
          {testimonials.map((testimonial, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.4
        }} whileHover={{
          y: -2
        }} whileTap={{
          scale: 0.98
        }} className="bg-cream rounded-2xl p-5 sm:p-7 border-l-4 border-green-light cursor-default" data-id="element-273">
              <p className="text-sm sm:text-base leading-relaxed text-gray-800 mb-4 sm:mb-5 italic" data-id="element-274">
                {testimonial.text}
              </p>
              <div className="flex items-center gap-3" data-id="element-275">
                <div className="w-9 h-9 sm:w-10 sm:h-10 bg-gradient-to-br from-green to-navy rounded-full flex items-center justify-center text-white font-bold text-sm sm:text-base flex-shrink-0" data-id="element-276">
                  {testimonial.initial}
                </div>
                <div data-id="element-277">
                  <div className="font-semibold text-xs sm:text-sm text-navy" data-id="element-278">
                    {testimonial.name}
                  </div>
                  <div className="text-[11px] sm:text-xs text-gray" data-id="element-279">
                    {testimonial.role}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}